import get from 'lodash/get';
import { useMemo } from 'react';
import { useAuth } from 'src/utils/auth';
import type { TUser } from 'src/types';
import { useGetUserDetails } from 'src/hooks/queries/users/useGetUserDetails';

export const useGetCurrentUser = (): TUser & {
    isAdmin: boolean;
    isManager: boolean;
    isEmployee: boolean;
} => {
    const { user: currentUserData } = useAuth();
    const authUser = get(currentUserData, 'profile.user', {});
    const { data: profile } = useGetUserDetails(authUser.id);

    return useMemo(() => {
        const {
            id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            created_at,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            modified_at,
            firstName,
            lastName,
            email,
            role,
            isAdmin,
            isManager,
            isEmployee,
        } = authUser;
        return {
            id,
            created_at,
            modified_at,
            firstName,
            lastName,
            email,
            role,
            manager: profile?.manager || null,
            isAdmin,
            isManager,
            isEmployee,
        };
    }, [authUser, profile]);
};
